export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5212.8319e7a5.jpg";